export const promoCodeExperimentValues = {
  control: "0",
  promo_bar: "1",
  promo_box: "2",
  throwaway: "3"
};

export const showPromoCodeVariants = ["0", "1", "2"];

export const showPromoCodeEnabled = ["1", "2"];

export const promoCodeValue = "20OFFBP";
